import { render, staticRenderFns } from "./EditEmmaChatForm.vue?vue&type=template&id=6f87ed02&"
import script from "./EditEmmaChatForm.vue?vue&type=script&lang=ts&"
export * from "./EditEmmaChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports